import { render } from "./NotificationIndicator.vue?vue&type=template&id=1d970b8d&scoped=true"
import script from "./NotificationIndicator.vue?vue&type=script&lang=js"
export * from "./NotificationIndicator.vue?vue&type=script&lang=js"

import "./NotificationIndicator.vue?vue&type=style&index=0&id=1d970b8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d970b8d"]])

export default __exports__